import tw from 'twin.macro';
import styled from 'styled-components';

const Heading4 = styled.h4(() => [tw`text-2xl md:text-3xl mt-7 mb-5 font-medium`]);

export default Heading4;
